import { Button, RegularModal } from '@/ui-kit';

type DeleteGroupItemModalProps = {
  title: string;
  isOpen: boolean;
  /** Breadcrumbs of the answers the removal clears; none keeps the plain confirmation. */
  affectedAnswers?: string[];
  onCancel: () => void;
  onConfirm: React.MouseEventHandler<HTMLButtonElement>;
};

export const DeleteGroupItemModal: React.FC<DeleteGroupItemModalProps> = ({
  title,
  isOpen,
  affectedAnswers = [],
  onCancel,
  onConfirm,
}) => {
  return (
    <RegularModal
      size="small"
      onClose={onCancel}
      isOpen={isOpen}
      id="deleteGroupItemModal"
      title={`Remove ${title}?`}
      description={
        affectedAnswers.length === 0 ? (
          'This action cannot be undone.'
        ) : (
          <>
            <p>These answers point at this location and will be removed:</p>
            <ul className="my-2 max-h-[35vh] overflow-y-auto list-disc pl-5">
              {affectedAnswers.map(answer => (
                <li key={answer}>{answer}</li>
              ))}
            </ul>
            <p>This action cannot be undone.</p>
          </>
        )
      }
      buttons={{
        variant: 'double',
        list: [
          <Button
            variant="primary"
            size="regular"
            kind="danger"
            onClick={onConfirm}
          >
            Remove
          </Button>,
          <Button
            variant="tertiary"
            size="regular"
            kind="default"
            onClick={onCancel}
          >
            Cancel
          </Button>,
        ],
      }}
    />
  );
};
